__turbopack_context__.v({
  "info": "sticky-header-module-scss-module__1owZmq__info",
  "sticky-header-container": "sticky-header-module-scss-module__1owZmq__sticky-header-container",
  "title": "sticky-header-module-scss-module__1owZmq__title",
});
